import type { ApiError } from '@/types'

export function isApiError(error: unknown): error is ApiError {
  return (
    typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    typeof (error as ApiError).message === 'string' &&
    'statusCode' in error &&
    typeof (error as ApiError).statusCode === 'number'
  )
}

export function getApiErrorMessage(error: unknown, fallback = 'Request failed'): string {
  if (isApiError(error)) return error.message
  if (error instanceof Error) return error.message
  return fallback
}

export function getApiErrorStatus(error: unknown): number | undefined {
  return isApiError(error) ? error.statusCode : undefined
}

export function isJobUnavailableError(error: unknown): boolean {
  return getApiErrorStatus(error) === 410
}
